﻿// Visor 3D del buzo: malla "inflada" a partir del recorte (frente con estampado, espalda negra lisa).
// Uso: mountHoodie(contenedor, { rim: '#b3121a', speed: 0.35, interactive: true, caja: false })
// Con caja: true el buzo sale de una caja de cartón corrugado negro modelada en la misma escena.
// Script clásico (no módulo) para que funcione también abriendo el HTML con doble clic (file://):
// necesita antes three.min.js (global THREE) y hoodie3d-texturas.js (texturas en data URI).
(function () {
const TEX = window.NERISSA_TEXTURAS;

function loadImage(src) {
  return new Promise((res, rej) => {
    const img = new Image();
    img.onload = () => res(img);
    img.onerror = rej;
    img.src = src;
  });
}

function sampler(img) {
  const c = document.createElement('canvas');
  c.width = img.width; c.height = img.height;
  const ctx = c.getContext('2d', { willReadFrequently: true });
  ctx.drawImage(img, 0, 0);
  const { data } = ctx.getImageData(0, 0, c.width, c.height);
  const W = c.width, H = c.height;
  return (u, v) => {
    const x = Math.min(W - 1, Math.max(0, u * (W - 1)));
    const y = Math.min(H - 1, Math.max(0, (1 - v) * (H - 1)));
    const x0 = x | 0, y0 = y | 0, x1 = Math.min(W - 1, x0 + 1), y1 = Math.min(H - 1, y0 + 1);
    const fx = x - x0, fy = y - y0;
    const p = (xx, yy) => data[(yy * W + xx) * 4] / 255;
    return (p(x0, y0) * (1 - fx) + p(x1, y0) * fx) * (1 - fy) + (p(x0, y1) * (1 - fx) + p(x1, y1) * fx) * fy;
  };
}

// ---------- caja de cartón corrugado ----------
function lienzo(w, h, dibujar) {
  const c = document.createElement('canvas');
  c.width = w; c.height = h;
  dibujar(c.getContext('2d'), w, h);
  return c;
}

// estrías del corrugado: color + relieve
function estrias(g, w, h, base) {
  g.fillStyle = base; g.fillRect(0, 0, w, h);
  for (let x = 0; x < w; x += 2) {
    const s = 0.5 + 0.5 * Math.sin((x / 14) * Math.PI * 2);
    g.fillStyle = `rgba(255,255,255,${0.012 + s * 0.03})`;
    g.fillRect(x, 0, 2, h);
  }
  for (let i = 0; i < 1400; i++) { // fibras y polvo
    g.fillStyle = `rgba(${Math.random() > 0.5 ? '255,255,255' : '0,0,0'},${Math.random() * 0.05})`;
    g.fillRect(Math.random() * w, Math.random() * h, 1 + Math.random() * 2, 1 + Math.random() * 6);
  }
}
function relieve(g, w, h) {
  g.fillStyle = '#808080'; g.fillRect(0, 0, w, h);
  for (let x = 0; x < w; x++) {
    const s = 0.5 + 0.5 * Math.sin((x / 14) * Math.PI * 2);
    const v = Math.round(90 + s * 80);
    g.fillStyle = `rgb(${v},${v},${v})`; g.fillRect(x, 0, 1, h);
  }
}
// canto cortado: la onda del corrugado vista de lado
function canto(g, w, h) {
  g.fillStyle = '#2b2725'; g.fillRect(0, 0, w, h);
  g.strokeStyle = '#5a514c'; g.lineWidth = 3;
  g.beginPath();
  for (let x = 0; x <= w; x += 2) g.lineTo(x, h / 2 + Math.sin(x / 9) * (h * 0.32));
  g.stroke();
  g.fillStyle = '#3c3532'; g.fillRect(0, 0, w, 4); g.fillRect(0, h - 4, w, 4);
}
// cinta de embalaje con impresión repetida y puntas rasgadas
function cinta(g, w, h) {
  g.clearRect(0, 0, w, h);
  g.beginPath();
  const dientes = (y0, dir) => { for (let x = 0; x <= w; x += w / 9) g.lineTo(x, y0 + dir * (Math.random() * 18)); };
  g.moveTo(0, 14); dientes(10, 1); g.lineTo(w, h - 14);
  for (let x = w; x >= 0; x -= w / 9) g.lineTo(x, h - 10 - Math.random() * 18);
  g.closePath();
  const grd = g.createLinearGradient(0, 0, w, 0);
  grd.addColorStop(0, '#221f1e'); grd.addColorStop(0.5, '#2f2a28'); grd.addColorStop(1, '#201d1c');
  g.fillStyle = grd; g.fill();
  g.save(); g.clip();
  g.fillStyle = '#6a605a'; g.font = '700 30px "Chivo Mono", monospace'; g.textAlign = 'center';
  for (let y = 60; y < h; y += 150) { g.save(); g.translate(w / 2, y); g.rotate(-Math.PI / 2); g.fillText('NERISSA', 0, 10); g.restore(); }
  g.fillStyle = 'rgba(255,255,255,.05)'; g.fillRect(w * 0.18, 0, w * 0.08, h);
  g.restore();
}

function crearCaja(renderer, { W = 2.5, D = 1.9, H = 0.95, rimY = -0.55, t = 0.035 } = {}) {
  const caja = new THREE.Group();
  const aniso = renderer.capabilities.getMaxAnisotropy();
  const colorC = lienzo(512, 512, (g, w, h) => estrias(g, w, h, '#1f1c1b'));
  const bumpC = lienzo(512, 64, relieve);
  const cantoC = lienzo(256, 32, canto);
  const textura = (c, rx, ry, color = true) => {
    const tx = new THREE.CanvasTexture(c);
    if (color) tx.colorSpace = THREE.SRGBColorSpace;
    tx.wrapS = tx.wrapT = THREE.RepeatWrapping; tx.repeat.set(rx, ry); tx.anisotropy = aniso;
    return tx;
  };
  const carton = (w, h) => new THREE.MeshStandardMaterial({ map: textura(colorC, w * 0.9, h * 0.9), bumpMap: textura(bumpC, w * 0.9, 1, false), bumpScale: 0.6, roughness: 0.93 });
  const cantoMat = new THREE.MeshStandardMaterial({ map: textura(cantoC, 1, 1), roughness: 0.95 });

  // placa con caras grandes de cartón y cantos con la onda del corrugado
  const placa = (w, h, d, frente) => {
    const dims = [w, h, d];
    const delgado = dims.indexOf(Math.min(...dims)); // 0:x 1:y 2:z
    const grandes = delgado === 0 ? [d, h] : delgado === 1 ? [w, d] : [w, h];
    const mCara = frente || carton(...grandes);
    const mats = [0, 1, 2, 3, 4, 5].map(i => (Math.floor(i / 2) === delgado ? mCara : cantoMat));
    const m = new THREE.Mesh(new THREE.BoxGeometry(w, h, d), mats);
    m.castShadow = true; m.receiveShadow = true;
    return m;
  };

  // pared delantera con el estampado en esténcil
  const frenteC = lienzo(1024, 400, (g, w, h) => {
    estrias(g, w, h, '#211e1d');
    g.fillStyle = '#4d4643'; g.textAlign = 'center';
    g.font = '700 112px "Stardos Stencil", serif'; g.fillText('NERISSA', w / 2, 318);
    g.font = '600 30px "Chivo Mono", monospace'; g.fillText('DROP 01  ·  KUMO  ·  M / L', w / 2, 372);
    g.strokeStyle = '#4d4643'; g.lineWidth = 7; g.lineCap = 'round'; g.lineJoin = 'round';
    g.beginPath(); // este lado arriba
    for (const x of [92, 132]) { g.moveTo(x, 370); g.lineTo(x, 290); g.moveTo(x - 16, 306); g.lineTo(x, 290); g.lineTo(x + 16, 306); }
    g.moveTo(66, 382); g.lineTo(158, 382);
    g.moveTo(870, 320); g.arc(910, 320, 40, Math.PI, 0); g.closePath(); // paraguas
    g.moveTo(910, 320); g.lineTo(910, 366); g.arc(898, 366, 12, 0, Math.PI);
    g.stroke();
  });
  const frenteMat = new THREE.MeshStandardMaterial({ map: textura(frenteC, 1, 1), bumpMap: textura(bumpC, 2.2, 1, false), bumpScale: 0.6, roughness: 0.93 });

  const yMid = rimY - H / 2;
  const pf = placa(W, H, t, frenteMat); pf.position.set(0, yMid, D / 2); caja.add(pf);
  const pb = placa(W, H, t); pb.position.set(0, yMid, -D / 2); caja.add(pb);
  const pl = placa(t, H, D); pl.position.set(-W / 2, yMid, 0); caja.add(pl);
  const pr = placa(t, H, D); pr.position.set(W / 2, yMid, 0); caja.add(pr);
  const piso = placa(W, t, D); piso.position.set(0, rimY - H, 0); caja.add(piso);

  // solapas abiertas, cada una con su bisagra en el borde superior
  const Lf = 0.8, Ls = 0.72;
  const solapa = (w, l, ejeZ) => {
    const g = new THREE.Group();
    const m = ejeZ ? placa(t, l, w) : placa(w, l, t);
    m.position.y = l / 2;
    g.add(m);
    return { g, m };
  };
  const sf = solapa(W, 0.46, false); sf.g.position.set(0, rimY, D / 2); sf.g.rotation.x = 2.72; caja.add(sf.g);
  const sb = solapa(W, Lf, false); sb.g.position.set(0, rimY, -D / 2); sb.g.rotation.x = -0.32; caja.add(sb.g);
  const sl = solapa(D, Ls, true); sl.g.position.set(-W / 2, rimY, 0); sl.g.rotation.z = 1.95; caja.add(sl.g);
  const sr = solapa(D, Ls, true); sr.g.position.set(W / 2, rimY, 0); sr.g.rotation.z = -1.95; caja.add(sr.g);

  // cinta cortada: un tramo en la solapa delantera y otro en la trasera
  const cintaMat = new THREE.MeshStandardMaterial({ map: textura(lienzo(128, 512, cinta), 1, 1), transparent: true, alphaTest: 0.4, roughness: 0.38, metalness: 0.05, side: THREE.DoubleSide });
  const tf = new THREE.Mesh(new THREE.PlaneGeometry(0.34, 0.44), cintaMat);
  tf.position.set(0, 0.23, -t / 2 - 0.003); tf.rotation.y = Math.PI; sf.g.add(tf);
  const tb = new THREE.Mesh(new THREE.PlaneGeometry(0.34, Lf * 0.7), cintaMat);
  tb.position.set(0, Lf * 0.35, t / 2 + 0.003); sb.g.add(tb);

  return caja;
}

async function mountHoodie(el, opts = {}) {
  const o = {
    rim: '#b3121a',      // luz de contorno (acento)
    rimIntensity: 2.2,
    key: '#f2ece4',
    speed: 0.35,         // rad/s de giro automático
    interactive: true,
    depth: 0.2,          // volumen de cada cara
    exposure: 1.05,
    tilt: 0.06,
    zoom: 1,
    shadow: true,
    caja: false,
    ...opts,
  };
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  let renderer;
  try {
    if (!window.THREE) throw new Error('three.js no cargó (¿sin internet?)');
    renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: 'high-performance' });
  } catch (e) {
    el.innerHTML = `<img src="${TEX.front}" alt="Buzo" style="width:100%;height:100%;object-fit:contain">`;
    return null;
  }
  renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = o.exposure;
  if (o.caja) { renderer.shadowMap.enabled = true; renderer.shadowMap.type = THREE.VSMShadowMap; }
  renderer.domElement.style.cssText = 'width:100%;height:100%;display:block;touch-action:pan-y;cursor:grab';
  el.appendChild(renderer.domElement);

  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(28, 1, 0.1, 60);
  camera.position.set(0, 0.05, 5.4 / o.zoom);

  if (o.caja) await Promise.all(['700 128px "Stardos Stencil"', '600 30px "Chivo Mono"', '700 30px "Chivo Mono"'].map(f => document.fonts.load(f).catch(() => {})));
  const [front, back, height] = await Promise.all([TEX.front, TEX.back, TEX.height].map(loadImage));
  const hAt = sampler(height);
  const aspect = front.width / front.height;
  const PH = 2, PW = PH * aspect;

  const geo = new THREE.PlaneGeometry(PW, PH, 170, Math.round(170 / aspect));
  const pos = geo.attributes.position, uv = geo.attributes.uv;
  // el perfil arranca en 0 justo en el borde del recorte para que frente y espalda queden cerrados
  for (let i = 0; i < pos.count; i++) pos.setZ(i, Math.max(0, (hAt(uv.getX(i), uv.getY(i)) - 0.3) / 0.7) * o.depth);
  geo.computeVertexNormals();

  const backGeo = geo.clone();
  const bp = backGeo.attributes.position;
  for (let i = 0; i < bp.count; i++) bp.setZ(i, -bp.getZ(i));
  backGeo.computeVertexNormals();

  const tex = img => {
    const t = new THREE.Texture(img);
    t.colorSpace = THREE.SRGBColorSpace;
    t.anisotropy = renderer.capabilities.getMaxAnisotropy();
    t.needsUpdate = true;
    return t;
  };
  const mat = map => new THREE.MeshStandardMaterial({ map, alphaTest: 0.5, roughness: 0.92, metalness: 0 });
  const frontTex = tex(front), backTex = tex(back);
  const frontMat = mat(frontTex);
  const backMat = mat(backTex);
  backMat.side = THREE.BackSide;

  const hoodie = new THREE.Group();
  const mf = new THREE.Mesh(geo, frontMat), mb = new THREE.Mesh(backGeo, backMat);
  // la sombra respeta la silueta del recorte, no el rectángulo del plano
  mf.customDepthMaterial = new THREE.MeshDepthMaterial({ depthPacking: THREE.RGBADepthPacking, map: frontTex, alphaTest: 0.5 });
  mb.customDepthMaterial = new THREE.MeshDepthMaterial({ depthPacking: THREE.RGBADepthPacking, map: backTex, alphaTest: 0.5, side: THREE.BackSide });
  mf.castShadow = mb.castShadow = true;
  hoodie.add(mf, mb);
  const pivot = new THREE.Group();
  pivot.add(hoodie);
  scene.add(pivot);

  scene.add(new THREE.HemisphereLight(0xffffff, 0x1a1a1a, o.caja ? 1.25 : 1.6));
  const key = new THREE.DirectionalLight(o.key, o.caja ? 1.9 : 1.5); key.position.set(-2.5, 3.2, 4); scene.add(key);
  const rimL = new THREE.DirectionalLight(o.rim, o.rimIntensity); rimL.position.set(3, 1.2, -3); scene.add(rimL);
  const rimR = new THREE.DirectionalLight(o.rim, o.rimIntensity * 0.7); rimR.position.set(-3, 0.4, -2.5); scene.add(rimR);
  const backFill = new THREE.DirectionalLight(0xffffff, 0.9); backFill.position.set(0.5, 2.5, -4); scene.add(backFill);

  let shadow, lift = 0;
  if (o.caja) {
    lift = 0.12;
    // luz cenital suave: la sombra del buzo cae al fondo de la caja, corta y difusa, no contra la solapa
    const cenital = new THREE.DirectionalLight(0xffffff, 0.7);
    cenital.position.set(-0.6, 6, 1.2);
    scene.add(cenital);
    cenital.castShadow = true;
    cenital.shadow.mapSize.set(1024, 1024);
    Object.assign(cenital.shadow.camera, { left: -2.5, right: 2.5, top: 2.5, bottom: -2.5, near: 1, far: 12 });
    cenital.shadow.bias = -0.0005; cenital.shadow.radius = 10; cenital.shadow.blurSamples = 16;
    scene.add(crearCaja(renderer));
  } else if (o.shadow) {
    const c = document.createElement('canvas'); c.width = c.height = 256;
    const g = c.getContext('2d');
    const grd = g.createRadialGradient(128, 128, 0, 128, 128, 128);
    grd.addColorStop(0, 'rgba(0,0,0,0.75)'); grd.addColorStop(1, 'rgba(0,0,0,0)');
    g.fillStyle = grd; g.fillRect(0, 0, 256, 256);
    const st = new THREE.CanvasTexture(c);
    shadow = new THREE.Mesh(new THREE.PlaneGeometry(PW * 1.1, 0.5), new THREE.MeshBasicMaterial({ map: st, transparent: true, depthWrite: false }));
    shadow.rotation.x = -Math.PI / 2;
    shadow.position.y = -PH / 2 - 0.08;
    scene.add(shadow);
  }

  // interacción: arrastrar para girar, con inercia
  let angle = -0.5, vel = 0, dragging = false, lastX = 0, idle = 0, auto = true;
  if (o.interactive) {
    const c = renderer.domElement;
    c.addEventListener('pointerdown', e => { dragging = true; lastX = e.clientX; c.setPointerCapture(e.pointerId); c.style.cursor = 'grabbing'; });
    c.addEventListener('pointermove', e => { if (!dragging) return; const dx = e.clientX - lastX; lastX = e.clientX; vel = dx * 0.012; angle += vel; idle = 0; });
    const up = () => { dragging = false; c.style.cursor = 'grab'; };
    c.addEventListener('pointerup', up); c.addEventListener('pointercancel', up);
  }

  const resize = () => {
    const w = el.clientWidth || 1, h = el.clientHeight || 1;
    renderer.setSize(w, h, false);
    camera.aspect = w / h;
    const tan = 2 * Math.tan(THREE.MathUtils.degToRad(camera.fov / 2));
    if (o.caja) {
      // encuadre de la caja: en pantallas angostas el cartón se sale por los lados y el buzo manda
      const angosto = camera.aspect < 0.95;
      const z = (angosto
        ? Math.max(2.25 / tan, 1.95 / (tan * camera.aspect))
        : Math.max(3.35 / tan, 4.1 / (tan * camera.aspect))) / o.zoom;
      camera.position.set(0, z * 0.2, z);
      camera.lookAt(0, angosto ? -0.12 : -0.36, 0);
    } else {
      // encuadre: que el buzo quepa completo tanto en vertical como horizontal
      camera.position.z = Math.max((PH * 1.18) / tan, (PW * 1.25) / (tan * camera.aspect)) / o.zoom;
    }
    camera.updateProjectionMatrix();
  };
  new ResizeObserver(resize).observe(el);
  resize();

  let visible = true;
  new IntersectionObserver(([en]) => { visible = en.isIntersecting; }).observe(el);

  const clock = new THREE.Clock();
  renderer.setAnimationLoop(() => {
    if (!visible) return;
    const dt = Math.min(clock.getDelta(), 0.05);
    const t = clock.elapsedTime;
    if (!dragging) {
      idle += dt;
      vel *= 0.94;
      angle += vel;
      if (auto && !reduce && idle > 1.2) angle += o.speed * dt * Math.min(1, (idle - 1.2));
    }
    pivot.rotation.y = angle;
    pivot.rotation.x = o.tilt;
    pivot.position.y = lift + (reduce ? 0 : Math.sin(t * 1.1) * 0.03);
    if (shadow) shadow.scale.setScalar(1 - pivot.position.y * 1.5);
    if (o.onFrame) o.onFrame(angle);
    renderer.render(scene, camera);
  });

  return { renderer, scene, camera, setRotation: a => { angle = a; }, setAuto: v => { auto = v; } };
}

window.mountHoodie = mountHoodie;
})();
